import { render, staticRenderFns } from "./essential_information.vue?vue&type=template&id=59837c50&scoped=true"
import script from "./essential_information.vue?vue&type=script&lang=js"
export * from "./essential_information.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59837c50",
  null
  
)

export default component.exports